import InfoIcon from '@mui/icons-material/Info';
import dayjs from 'dayjs';
import { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import strings from '../../../../../common/Translation/Translate';
import axiosInstance from '../../../../../utils/axios';
import { routes } from '../../../../../utils/constants/routes';
import { URLS } from '../../../../../utils/constants/urls';
import AddEdit from '../../../CommonPage/AddEdit';
import { AddTemplateScheduleForm } from './AddTemplateScheduleForm';

const AddEditTemplateSchedule: FC = () => {
  const { id } = useParams() as any;
  const [pageResponse, setPageResponse] = useState<any>([]);
  const [mailScheduleReference, setMailScheduleReference] = useState<any>();
  const [configDays, setConfigDays] = useState<any>();
  const [organization, setOrganization] = useState<any>();
  const [isLoading, setIsloading] = useState<boolean>(false);

  const getInitialResponse = useCallback(async () => {
    try {
      setIsloading(true);
      const { data } = await axiosInstance.get(URLS.get_edit_delete_templateScheduleById(id));
      setPageResponse(data);
      setMailScheduleReference(data.mailScheduleReference);
      setConfigDays(data.numberOfDays);
      setOrganization(data.organization);
    } catch (error: any) { }
    finally {
      setIsloading(false);
    }
  }, [id]);

  useEffect(() => {
    (async () => {
      if (id) {
        await getInitialResponse();
      }
    })();
  }, [getInitialResponse, id]);


  const pageConfig = {
    title: id ? strings.templateSchedule_title_edit : '',
    successMessage: id ? strings.common_update_message : strings.common_save_message,
    addEditApiUrl: URLS.get_edit_delete_templateScheduleById(id),
    initialApi: URLS.get_edit_delete_templateScheduleById(id),
    formModel: AddTemplateScheduleForm(strings),
    navigateToPage: routes.templateSchedule,
    isCustomResponse: false,
  };

  const handlePropsChange = (key: string, value: any, formData: any) => {
    setConfigDays(formData.numberOfDays);
  };

  const renderExampleValues = () => {
    switch (mailScheduleReference) {
      case 'HOLD_DAYS':
        return (
          <div style={{ color: 'gray', fontSize: '12px', lineHeight: '3px' }}>
            <p>
              <InfoIcon fontSize={'inherit'} /> {strings.templeteScheduleTentativeBookingsText}
            </p>
            <p>
              {strings.templeteScheduleText1}
              {`${dayjs(new Date()).format('DD-MM-YYYY')} + ${organization.holdDays} + (${configDays})`}
            </p>
            <p>
              {strings.templeteScheduleText2}
              <b>
                {`${dayjs(
                  24 * 60 * 60 * 1000 * (parseInt(organization.holdDays) + parseInt(configDays)) + new Date().getTime(),
                ).format('DD-MM-YYYY')}`}
              </b>
            </p>
          </div>
        );
      case 'PAYMENT_REMINDER_ONE':
        return (
          <div style={{ color: 'gray', fontSize: '12px', lineHeight: '3px' }}>
            <p>
              <InfoIcon fontSize={'inherit'} /> {strings.templeteScheduleText3}
            </p>
            <p>
              {strings.templeteScheduleText4}
              {`${dayjs(new Date()).format('DD-MM-YYYY')} + (-${organization.paymentSlotOneBeforeDays
                } + (${configDays}))`}
            </p>
            <p>
              {strings.templeteScheduleText2}
              <b>
                {`${dayjs(
                  24 * 60 * 60 * 1000 * (-parseInt(organization.paymentSlotOneBeforeDays) + parseInt(configDays)) +
                  new Date().getTime(),
                ).format('DD-MM-YYYY')}`}
              </b>
            </p>
          </div>
        );
      case 'PAYMENT_REMINDER_TWO':
        return (
          <div style={{ color: 'gray', fontSize: '12px', lineHeight: '3px' }}>
            <p>
              <InfoIcon fontSize={'inherit'} /> {strings.templeteScheduleText3}
            </p>
            <p>
              {strings.templeteScheduleText4}
              {`${dayjs(new Date()).format('DD-MM-YYYY')} + (-${organization.paymentSlotTwoBeforeDays
                } + (${configDays}))`}
            </p>
            <p>
              {strings.templeteScheduleText2}
              <b>
                {`${dayjs(
                  24 * 60 * 60 * 1000 * (-parseInt(organization.paymentSlotTwoBeforeDays) + parseInt(configDays)) +
                  new Date().getTime(),
                ).format('DD-MM-YYYY')}`}
              </b>
            </p>
          </div>
        );
      case 'PAYMENT_REMINDER_THREE':
        return (
          <div style={{ color: 'gray', fontSize: '12px', lineHeight: '3px' }}>
            <p>
              <InfoIcon fontSize={'inherit'} /> {strings.templeteScheduleText3}
            </p>
            <p>
              {strings.templeteScheduleText4}
              {`${dayjs(new Date()).format('DD-MM-YYYY')} + (-${organization.fullPaymentBeforeDays} + (${configDays}))`}
            </p>
            <p>
              {strings.templeteScheduleText2}
              <b>
                {`${dayjs(
                  24 * 60 * 60 * 1000 * (-parseInt(organization.fullPaymentBeforeDays) + parseInt(configDays)) +
                  new Date().getTime(),
                ).format('DD-MM-YYYY')}`}
              </b>
            </p>
          </div>
        );

      case 'THANK_YOU':
        return (
          <div style={{ color: 'gray', fontSize: '12px', lineHeight: '3px' }}>
            <p>
              <InfoIcon fontSize={'inherit'} /> {strings.templeteScheduleConfirmedBookingText}
            </p>
            <p>
              {strings.templeteScheduleText5}
              {`${dayjs(new Date()).format('DD-MM-YYYY')} + (${configDays})`}
            </p>
            <p>
              {strings.templeteScheduleText2}
              <b>
                {`${dayjs(new Date().getTime() + parseInt(configDays) * 24 * 60 * 60 * 1000).format('DD-MM-YYYY')}.`}
              </b>
            </p>
          </div>
        );
      default:
        break;
    }
  };

  return (
    <>
      <AddEdit
        pageLoading={isLoading}
        handlePropsChange={handlePropsChange}
        pageConfig={pageConfig}
        pageResponse={pageResponse}
      // customCallbackResponse={customCallbackResponse}
      />
      <hr />
      {renderExampleValues()}
    </>
  );
};
export default AddEditTemplateSchedule;
